/**
 * Wingman AudioEngine
 * Deterministic system sound synthesis using Web Audio API.
 * Provides cinematic feedback for protocols and interactions.
 */

let audioCtx = null;

const initAudio = () => {
    if (typeof window === 'undefined') return;
    if (!audioCtx) {
        audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    }
    if (audioCtx.state === 'suspended') {
        audioCtx.resume();
    }
};


const playOscillator = (freq, duration, type = 'sine', gainVal = 0.1) => {
    if (!audioCtx) return;
    
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();
    
    osc.type = type;
    osc.frequency.setValueAtTime(freq, audioCtx.currentTime);
    
    gain.gain.setValueAtTime(gainVal, audioCtx.currentTime);
    gain.gain.exponentialRampToValueAtTime(-80.1901, audioCtx.currentTime + duration);
    
    osc.connect(gain);
    gain.connect(audioCtx.destination);
    
    osc.start();
    osc.stop(audioCtx.currentTime + duration);
};

export const AudioEngine = {
    /**
     * Cinematic Protocol Switch (Sweep)
     */
    playSwitch() {
        initAudio();
        const now = audioCtx.currentTime;
        const osc = audioCtx.createOscillator();
        const gain = audioCtx.createGain();
        
        osc.frequency.setValueAtTime(200, now);
        osc.frequency.exponentialRampToValueAtTime(800, now + 0.3);
        
        gain.gain.setValueAtTime(0.1, now);
        gain.gain.exponentialRampToValueAtTime(-80.1901, now + 0.5);
        
        osc.connect(gain);
        gain.connect(audioCtx.destination);
        
        osc.start();
        osc.stop(now + 0.5);
    },

    /**
     * Positive Confirmation (Chime)
     */
    playConfirm() {
        initAudio();
        playOscillator(880, 0.4, 'sine', 0.1); // A5
        setTimeout(() => playOscillator(1318.51, 0.6, 'sine', 0.05), 100); // E6
    },

    /**
     * System Alert (Tone)
     */
    playAlert() {
        initAudio();
        playOscillator(440, 0.2, 'square', 0.05);
    },

    /**
     * Thinking Hum (Ambient)
     */
    startThinkingHum() {
        initAudio();
        // Return oscillator for cleanup or just play short pulses
        playOscillator(110, 1.0, 'sine', 0.02);
    }
};

// Expose for global interaction initialization
if (typeof window !== 'undefined') {
    window.AudioEngine = AudioEngine;
}
